<template>
  <div
    class="error-page"
  >
    <h1>{{ code }}</h1>
    <h2 class="h2">
      Ooops!
    </h2>
    <p class="body-1 col-6">
      {{ friendlyMessages[message] || friendlyMessagesByCode[code] || message }}
    </p>
    <nuxt-link to="/" class="btn-primary btn-lg">
      Take me Back to Reality
    </nuxt-link>
  </div>
</template>

<script>

export default {
  components: {
  },
  scrollToTop: true,
  props: {
    code: { type: Number, default: 404 },
    message: { type: String, default: '' },
  },
  data() {
    return {
    };
  },
  head() {
    return {
      titleTemplate: 'Page not found%s',
      meta: [
        {
          name: 'robots',
          content: 'noindex, nofollow',
        },
      ],
    };
  },
  computed: {
    friendlyMessages() {
      return {
        'Page not found': 'We can’t seem to find the page you are looking for.',
      };
    },
    friendlyMessagesByCode() {
      return {
        404: 'We can’t seem to find the page you are looking for.',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.error-page {
  padding: 60px 0;
  text-align: center;
  color: var(--main-dark);
  background-image: url('../assets/images/home-v3-bg.webp');
  background-color: var(--main-light-shade-1);

  h1 {
    font-size: 260px;
    line-height: 100%;
    margin: 0;
    color: var(--main-dark-light-3);
  }

  .h2 {
    margin: var(--spacing-40) 0 var(--spacing-16);
    font-size: 52px;
  }

  .body-1 {
    margin: 0 auto;
    padding: 0 var(--spacing-44);
  }

  .btn-primary {
    margin-top: 30px;
    width: 370px;
    height: 58px;
  }
}

@include bp($bp-laptop) {
  .error-page {
    h1 {
      font-size: 220px;
    }

    .h2 {
      font-size: 48px;
    }
  }
}

@include bp($bp-phone) {
  .error-page .btn-primary {
    width: 100%;
  }
}

@include bp($bp-mobile) {
  .error-page {
    padding: 40px 24px;

    h1 {
      font-size: 44.5vw;
    }

    .h2 {
      font-size: 40px;
      margin-top: 30px;
    }

    .body-1 {
      padding: 0;
    }
  }
}

@include bp($bp-tablet) {
  .error-page {
    h1 {
      font-size: 160px;
      line-height: 120px;
    }
  }
}

.fa {
  @include bp($bp-mobile) {
    .error-page {
      .h2 {
        margin-top: var(--spacing-40);
      }
    }
  }
}
</style>
